<template>
  <div>
    <div class="row mb-30">
      <div class="col-12">
        <account-type-tabs selected="students" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="dashboard-card">
          <loader v-if="!students" style="width: 100%" />

          <student-table
            v-else
            :students="students"
            :sorted-column="sortedColumn"
            :sorted-asc="sortedAsc"
            :on-sort="onSort"
            :send-message="sendMessage"
            :view-student="viewStudent"
            @impersonate="(id) => $emit('impersonate', id)"
          />

          <pagination
            v-if="count > limit"
            :filtered-count="count"
            :page="page"
            :page-size="limit"
            :on-page-changed="onPageChanged"
          />
        </div>
      </div>
    </div>

    <send-message-modal ref="sendMessageModal" />

    <view-student-modal
      ref="viewStudentModal"
      :reload-students="loadStudents"
    />
  </div>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import Loader from '@/components/Loader.vue';
import SendMessageModal from '@/components/modals/SendMessageModal.vue';
import Pagination from '@/components/Pagination.vue';
import AccountTypeTabs from './components/AccountTypeTabs.vue';
import StudentTable from './components/StudentTable.vue';
import ViewStudentModal from './components/ViewStudentModal.vue';

export default {
  name: 'SuperAdminStudents',

  components: {
    Loader,
    SendMessageModal,
    Pagination,
    AccountTypeTabs,
    StudentTable,
    ViewStudentModal
  },

  props: {
    search: {
      type: String,
      required: true
    },
    csvBus: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      adminClient: new AdminClient(this.$http),
      timeout: null,

      count: 0,
      page: 1,
      limit: 20,
      sortedColumn: 'date_joined',
      sortedAsc: false,

      students: null
    };
  },

  watch: {
    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => this.loadStudents(), 300);
    }
  },

  mounted() {
    this.csvBus.$on('generate', this.generateCsv);
    this.loadStudents();
  },

  destroyed() {
    this.csvBus.$off('generate', this.generateCsv);
  },

  methods: {
    async loadStudents() {
      const offset = (this.page - 1) * this.limit;
      const filters = {};

      if (this.search) {
        filters.search = this.search;
      }

      this.students = null;

      const response = await this.adminClient.getStudentsList(
        filters,
        this.limit,
        offset,
        this.sortedColumn,
        this.sortedAsc
      );

      this.students = response.results || [];
      this.count = response.count;
    },

    onSort(id) {
      if (id && id === this.sortedColumn) {
        this.sortedAsc = !this.sortedAsc;
      } else {
        this.sortedColumn = id;
        this.sortedAsc = true;
      }
      this.loadStudents();
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.students = null;
        this.loadStudents();
      }
    },

    sendMessage(filters) {
      this.$refs.sendMessageModal.show(filters.student);
    },
    async viewStudent(student) {
      this.$refs.viewStudentModal.show(student);
    },
    async generateCsv() {
      const filters = {};

      if (this.search) {
        filters.search = this.search;
      }

      try {
        const content = await this.adminClient.getStudentsListCSV(
          filters,
          this.sortedColumn,
          this.sortedAsc
        );
        this.csvBus.$emit('success', { content, file: 'students.csv' });
      } catch (e) {
        this.csvBus.$emit('error', e);
      }
    }
  }
};
</script>
